import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';

import { I18nProvider } from '@/shared/i18n/i18n-provider';

import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Project data changes when a colleague edits it, not on a timer. Refetch on focus
      // instead of polling, and keep a short stale window so tab-switching is instant.
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Never retry an auth or permission failure — the answer will not change.
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <RouterProvider router={router} />
      </I18nProvider>
    </QueryClientProvider>
  );
}
